import React, { useState } from "react";

import submit from "submit-form";
import Modal from "../../../../parts/modal-new";
import { OrganizationCoachesSectionComponent } from "../../../dashboard/settings/manage-coaches/OrganizationCoachesSectionComponent";
import ChooseCoach from "../../../dashboard/settings/manage-coaches/ChooseCoach";

export const AcknowledgeAthleteModal = ({ locals, athlete }) => {
  const {
    activeUserToRequest,
    usersOrganization = {
      organizationActiveUsers: [],
      organizationInactiveUsers: [],
    },
    activeUser,
  } = locals;
  const referAsClients = Boolean(activeUser.referAsClients);
  // active coaches from organization
  const { organizationActiveUsers = [] } = usersOrganization;

  // selected organization coach on the dropdown
  const [selectedOrganizationCoach, setSelectedOrganizationCoach] =
    useState(activeUser);

  // wether to show or hide the coaches list dropdown

  // callback when a coach is selected within the list
  const selectOrganizationCoach = (e, coach) => {
    setSelectedOrganizationCoach(coach);
  };

  // submitting the modal
  const triggerAcknowledgeAthlete = () => {
    // we need the coach to whom the athlete belongs to currently
    // to be able to get the list of athletes that that coach has

    submit(`/coaching-portal/athletes/acknowledge-athlete`, {
      method: "POST",
      body: {
        athleteId: athlete._id,
        // coach to whom the athlete will be assigned
        coachToId: selectedOrganizationCoach._id,
        // current athlete coach id
        coachFromId: athlete?.coach?._id,
      },
    });
  };

  return (
    <Modal
      width={525}
      className="acknowledge-athlete-modal"
      title={`Acknowledge ${referAsClients ? "Client" : "Athlete"}`}
    >
      <div className="body">
        <label>
          Select the coach to whom you want to assign the{" "}
          {referAsClients ? "client" : "athlete"}
        </label>
        <ChooseCoach
          activeUser={activeUser}
          organizationActiveUsers={organizationActiveUsers}
          onSelectCoach={selectOrganizationCoach}
          selectedCoach={selectedOrganizationCoach}
          classNames="dropdown-img"
        />
      </div>
      <footer className="footer">
        <button data-button-type="primary" onClick={triggerAcknowledgeAthlete}>
          Acknowledge
        </button>
      </footer>
    </Modal>
  );
};
